import React from 'react'
import { PlusIcon } from '@heroicons/react/24/outline'
import { Button, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { CentralAmparoPageHeader } from '../../components/centralAmparo/CentralAmparoPageHeader'
import { usePermission } from '../../hooks/usePermissions'
import { modulesService } from '../../services/modules'
import TriagemCasosTab from './TriagemCasosTab'

const MODULE_NAME = 'central_amparo_triagem'
const DEFAULT_MODULE_TITLE = 'Triagem'

type CreateAppointmentAction = {
  visible: boolean
  disabled: boolean
  onClick: () => void
}

const SupportCenterTriagem: React.FC = () => {
  const { hasPermission: canUpdate } = usePermission(MODULE_NAME, 'update')

  const [moduleInfo, setModuleInfo] = React.useState<{
    display_name: string
    description: string | null
  } | null>(null)
  const createClickRef = React.useRef<() => void>(() => {})
  const [showCreateAppointment, setShowCreateAppointment] = React.useState(false)
  const [createAppointmentDisabled, setCreateAppointmentDisabled] = React.useState(false)

  const handleCreateActionChange = React.useCallback((action: CreateAppointmentAction | null) => {
    if (!action?.visible) {
      setShowCreateAppointment(false)
      return
    }
    createClickRef.current = action.onClick
    setShowCreateAppointment(true)
    setCreateAppointmentDisabled(action.disabled)
  }, [])

  React.useEffect(() => {
    const loadModule = async () => {
      const result = await modulesService.getByName(MODULE_NAME)
      if (result.success && result.data) {
        setModuleInfo({
          display_name: result.data.display_name || DEFAULT_MODULE_TITLE,
          description: result.data.description || null,
        })
      }
    }
    void loadModule()
  }, [])

  return (
    <main className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900">
        <PermissionGuard
          moduleName={MODULE_NAME}
          permissionType="show"
          fallback={
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center">
                <Text size="xl" className="text-gray-500 dark:text-gray-400 mb-2">
                  Acesso Negado
                </Text>
                <Text size="sm" color="muted">
                  Você não tem permissão para acessar esta página.
                </Text>
              </div>
            </div>
          }
        >
          <div className="h-full flex flex-col px-6 pt-6 pb-6">
            <div className="mb-6">
              <CentralAmparoPageHeader
                title={moduleInfo?.display_name || DEFAULT_MODULE_TITLE}
                description={moduleInfo?.description}
                actions={
                  showCreateAppointment ? (
                    <Button
                      onClick={() => createClickRef.current()}
                      disabled={createAppointmentDisabled}
                    >
                      <PlusIcon className="h-4 w-4" aria-hidden="true" />
                      Novo agendamento
                    </Button>
                  ) : null
                }
              />
            </div>

            <div className="flex-1 flex flex-col min-h-0">
              <TriagemCasosTab
                canUpdate={!!canUpdate}
                onCreateActionChange={handleCreateActionChange}
              />
            </div>
          </div>
        </PermissionGuard>
    </main>
  )
}

export default SupportCenterTriagem
